// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_boxContainer__NKtml {
  overflow-x: auto;
  padding-top: 24px;
  padding-bottom: 24px;
}

.styles_header__2-qbk {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
  padding: 15px;
}

.styles_header__2-qbk p {
  color: #000;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_demo__7mZ\\+d {
  height: calc(100% - 216px) !important;
  margin: 20px 10px !important;
  min-height: unset !important;
  width: unset !important;
  overflow: hidden;
  border-radius: 10px;
}

.styles_ProfileMenuMiddle__rmeVB {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 15px 0;
  width: 100%;
}

.styles_ProfileMenuMiddle__rmeVB p {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #898989;
}

.styles_checkMarkStyle__DeiiH {
  width: 20px;
  height: 20px;
}

.styles_checkMarkStyle__DeiiH > input {
  display: none;
}

.styles_labelStyle__Iq59X {
  padding: 0 !important;
}

.styles_checkMarkStyle__DeiiH:after {
  left: 7px !important;
  top: 4px !important;
  width: 4px !important;
  height: 8px !important;
  border: solid white !important;
  border-width: 0 3px 3px 0 !important;
  transform: rotate(45deg) !important;
}

.styles_ProfileMenuMiddle__rmeVB .styles_color__JZR6F {
  box-sizing: border-box;
  width: 18px;
  height: 18px;
  border-radius: 8px;
  cursor: pointer;
}

.styles_itemBox__W8j\\+H {
  width: 70px;
  height: 100px;
  margin: 10px;
  background-size: 100px;
  min-width: 70px;
}

.styles_unActive__qddXg {
  box-shadow: 0px 0px 0px 1px gray;
  border-radius: 8px;
  position: relative;
}

.styles_activeColor__uFdGV {
  box-shadow: 0px 0px 0px 1px #d8000d;
  border-radius: 8px;
  position: relative;
}

.styles_ProfileMenuBottom__muKMU {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 8px 0;
  width: 100%;
  height: auto;
}

.styles_ProfileMenuBottom__muKMU > div,
.styles_ProfileMenuBottom__muKMU a {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: rgba(0, 0, 0, 0.54);
  border-radius: 4px;
  padding: 6px 5px;
  width: 100%;
  cursor: pointer;
}

.styles_ProfileMenuBottom__muKMU > div > span,
.styles_ProfileMenuBottom__muKMU > a > span {
  padding-right: 4px;
}

.styles_ProfileMenuBottom__muKMU > div:hover,
.styles_ProfileMenuBottom__muKMU > a:hover {
  background: #e8e8e8;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/BackgroudBox/styles.module.scss"],"names":[],"mappings":"AAEA;EAEE,gBAAA;EACA,iBAAA;EACA,oBAAA;AAFF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,aAAA;AADF;;AAMA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHF;;AAMA;EAIE,qCAAA;EAEA,4BAAA;EACA,4BAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAPF;;AASE;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;AANJ;;AAUE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAPJ;;AASE;EACE,WAAA;EACA,YAAA;AANJ;;AAQE;EACE,aAAA;AALJ;;AAOE;EACE,qBAAA;AAJJ;;AAME;EACE,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,8BAAA;EACA,oCAAA;EACA,mCAAA;AAHJ;;AAME;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,eAAA;AAJJ;;AAME;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;AAHJ;;AAKE;EAIE,gCAAA;EACA,kBAAA;EACA,kBAAA;AALJ;;AAoBE;EAGE,mCAAA;EACA,kBAAA;EACA,kBAAA;AAnBJ;;AAmCE;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAhCJ;;AAmCE;;EAEE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAhCJ;;AAmCE;;EAEE,kBAAA;AAhCJ;;AAmCE;;EAEE,mBAAA;AAhCJ","sourcesContent":["\n\n.boxContainer{\n  // max-height:42vh;\n  overflow-x:auto;\n  padding-top:24px;\n  padding-bottom:24px;\n}\n.header{\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  width:100%;\n  height:auto;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.50);\n  padding:15px;\n}\n.input{\n  \n}\n.header p{\n  color: #000;\n  text-align: center;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n\n}\n.demo{\n  // height: 48vh !important;\n  // height:30vh !important;\n  // height:calc( 100% - 360px) !important;\n  height:calc( 100% - 216px) !important;\n\n  margin:20px 10px !important;\n  min-height:unset !important;\n  width:unset !important;\n  overflow:hidden;\n  border-radius:10px;\n}\n  .ProfileMenuMiddle {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    padding: 15px 0;\n    width: 100%;\n    // border-bottom: 1px solid #d2d2d2;\n  }\n  \n  .ProfileMenuMiddle p {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 20px;\n    text-align: center;\n    color: #898989;\n  }\n  .checkMarkStyle{\n    width:20px;\n    height:20px;\n  }\n  .checkMarkStyle>input{\n    display: none;\n  }\n  .labelStyle{\n    padding: 0 !important;\n  }\n  .checkMarkStyle:after{\n    left: 7px !important;\n    top: 4px  !important;\n    width: 4px !important;\n    height: 8px !important;\n    border: solid white !important;\n    border-width: 0 3px 3px 0 !important;\n    transform: rotate(45deg) !important;\n\n  }\n  .ProfileMenuMiddle .color {\n    box-sizing: border-box;\n    width: 18px;\n    height: 18px;\n    border-radius: 8px;\n    // margin: 8px 2px;\n    cursor: pointer;\n  }\n  .itemBox{\n    width:70px;\n    height:100px;\n    margin:10px;\n    background-size: 100px;\n    min-width:70px;\n  }\n  .unActive {\n    // border: 1px solid #dddddd;\n    // outline: 1px solid gray;\n    // outline-offset: 1px;\n    box-shadow: 0px 0px 0px 1px gray;\n    border-radius: 8px;\n    position:relative;\n  }\n  // .unActive::after {\n  //   position: absolute;\n  //   top: -1px;\n  //   content: '';\n  //   left: -1px;\n  //   width: 20px;\n  //   height: 20px;\n  //   border: 1px solid gray;\n  //   border-radius: 40px;\n  //   background-color: transparent;\n  //   display: inherit;\n  // }\n  \n  .activeColor {\n    // outline: 2px solid #d8000d;\n    // outline-offset: 2px;\n    box-shadow: 0px 0px 0px 1px #d8000d;\n    border-radius:8px;\n    position:relative;\n  \n  }\n  // .activeColor::after {\n  //   position: absolute;\n  //   top: -1px;\n  //   content: '';\n  //   left: -1px;\n  //   width: 20px;\n  //   height: 20px;\n  //   border: 1px solid #d8000d;\n  //   border-radius: 40px;\n  //   background-color: transparent;\n  //   display: inherit;\n  // }\n  \n  .ProfileMenuBottom {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    padding: 8px 0;\n    width: 100%;\n    height: auto;\n  }\n  \n  .ProfileMenuBottom > div,\n  .ProfileMenuBottom a {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 20px;\n    text-align: center;\n    color: rgba(0, 0, 0, 0.54);\n    border-radius: 4px;\n    padding: 6px 5px;\n    width: 100%;\n    cursor: pointer;\n  }\n  \n  .ProfileMenuBottom > div > span,\n  .ProfileMenuBottom > a > span {\n    padding-right: 4px;\n  }\n  \n  .ProfileMenuBottom > div:hover,\n  .ProfileMenuBottom > a:hover {\n    background: #e8e8e8;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxContainer": `styles_boxContainer__NKtml`,
	"header": `styles_header__2-qbk`,
	"demo": `styles_demo__7mZ+d`,
	"ProfileMenuMiddle": `styles_ProfileMenuMiddle__rmeVB`,
	"checkMarkStyle": `styles_checkMarkStyle__DeiiH`,
	"labelStyle": `styles_labelStyle__Iq59X`,
	"color": `styles_color__JZR6F`,
	"itemBox": `styles_itemBox__W8j+H`,
	"unActive": `styles_unActive__qddXg`,
	"activeColor": `styles_activeColor__uFdGV`,
	"ProfileMenuBottom": `styles_ProfileMenuBottom__muKMU`
};
export default ___CSS_LOADER_EXPORT___;
